// styles
import './styles/graphic.scss';

export default function (props, container, isMobile) {
  const {
    color,
    data,
    fmtYearAbbrev,
    fmtYearFull,
    fmtMonth,
    height,
    initialWidth,
    initialHeight,
    margins,
    path,
    width,
    x,
    xAxis,
    y,
    yAxis,
    recessionData,
  } = props;

  const xTicks = isMobile ? 5 : 5;
  const yTicks = isMobile ? 5 : 5;

  const xGrid = xAxis(x)
    .ticks(xTicks)
    .tickFormat(d => (isMobile
      ? `\u2019${fmtYearAbbrev(d)}`
      : fmtYearFull(d)));

  // legend
  container.insert('ul', ':first-child')
    .attr('class', 'key')
    .selectAll('li')
    .data(data)
    .enter()
    .append('li')
    .attr('class', 'key-item')
    .html(d => `<span class='key-block' style='background-color:${color(d.id)};'></span> ${d.id}`);

  // svg
  const svg = container.append('svg')
    .attr('width', initialWidth)
    .attr('height', initialHeight);

  const g = svg.append('g')
    .attr('transform', `translate(${[margins.left, margins.top]})`);

  // x axis
  g.append('g')
    .attr('class', 'grid x')
    .attr('transform', `translate(${[0, height]})`)
    .call(xGrid);

 	// y axis
  const yGrid = g.append('g')
    .attr('class', 'grid y')
    .call(yAxis(y).ticks(yTicks));

  // add tick prefix or suffix here
  // `${d}M`
  // `$${d}`
  yGrid.selectAll('text')
    .text(d => `${d}%`);

  yGrid.selectAll('line').attr('x2', width);

  // recessions
  const recessions = g.append('g').attr('class', 'recessions');


  console.log(recessionData);
  recessions
    .selectAll('.recession')
    .data(recessionData)
    .enter()
    .append('rect')
    .attr('class', 'recession')
    .attr('transform', d => `translate(${[x(d.start), 0]})`)
    .attr('width', d => x(d.end) - x(d.start))
    .attr('height', height)
    .style('fill', 'grey')
    .style('fill-opacity', 0.09);
  // .style('fill-opacity', 0.09);

  recessions
    .append('text')
    .attr('class', 'label-recession')
    .attr('transform', `translate(${[x(new Date('1949-11-01')) - 5, y(14)]})`)
    .attr('text-anchor', 'start')
    .text('Recession');

  // lines
  const lines = g.append('g')
    .attr('class', 'lines')
    .selectAll('g')
    .data(data)
    .enter()
    .append('g')
    .attr('class', 'line');

  lines.append('path')
    .attr('stroke', d => color(d.id))
    .attr('d', d => path(d.values));

  // labels
  const label = lines.append('g')
    .attr('class', 'data-label');

  label.append('text')
    .attr('transform', (d) => {
      const d0 = d.values.find((val, index, arr) => index === arr.length - 1);
      const x0 = x(d0.date) + 3;
      const y0 = y(d0.value) - 5;
      return `translate(${[x0, y0]})`;
    })
    .style('text-anchor', 'end')
    .text((d) => {
      const d0 = d.values.find((val, index, arr) => index === arr.length - 1);
      const { value } = d0;
      return `${value.toFixed(1)}%`;
    });

  label.append('text')
    .attr('transform', (d) => {
      const d0 = d.values.find((val, index, arr) => index === arr.length - 1);
      const x0 = x(d0.date) + 3;
      const y0 = y(d0.value) - 22;
      return `translate(${[x0, y0]})`;
    })
    .style('text-anchor', 'end')
    .text((d) => {
      const d0 = d.values.find((val, index, arr) => index === arr.length - 1);
      const { value } = d0;
      return 'Dec. 2021';
    });
}
